export default __webpack_public_path__ + "static/media/Wings.29aeb554.png";